import { Component, Host, h } from "@stencil/core";

@Component({
    tag: "leichte-sprache-user-avatar",
    styleUrl: "leichte-sprache-user-avatar.scss",
})
export class LeichteSpracheUserAvatar {
    render() {
        return (
            <Host>
                <svg
                    aria-hidden="true"
                    version="1.1"
                    id="Layer_1"
                    viewBox="0 0 40 40"
                    x="0px"
                    xmlns="http://www.w3.org/2000/svg"
                    y="0px"
                >
                    <g>
                        <path
                            fill="none"
                            class="st0"
                            d="M20,1c10.5,0,19,8.5,19,19s-8.5,19-19,19S1,30.5,1,20S9.5,1,20,1 M20,0C9,0,0,9,0,20S9,40,20,40S40,31,40,20S31,0,20,0L20,0z"
                        />
                    </g>
                    <g>
                        <ellipse
                            stroke-miterlimit="10"
                            stroke="#101A2F"
                            fill="none"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            class="st1"
                            cx="20"
                            cy="16.2"
                            rx="7"
                            ry="10"
                        />
                        <g>
                            <path
                                stroke-miterlimit="10"
                                stroke="#241624"
                                fill="#c6e1f7"
                                clip-rule="evenodd"
                                fill-rule="evenodd"
                                class="st2"
                                d="M16.7,25.3c0,1.2-0.4,3.4-2.5,4.7c-3.1,1.9-6.5,0.6-9,3.3"
                            />
                            <path
                                stroke-miterlimit="10"
                                stroke="#241624"
                                fill="#c6e1f7"
                                clip-rule="evenodd"
                                fill-rule="evenodd"
                                class="st2"
                                d="M23.3,25.1c0,1.1,0.2,3.5,2.5,4.9c3.1,1.9,6.5,0.6,9,3.3"
                            />
                        </g>
                    </g>
                </svg>
            </Host>
        );
    }
}
